import React, { useEffect, useState } from 'react'
import styles from '../styles/pages/auth.module.css'
import useInput from '../hooks/input.hook'
import Input from '../components/UI/Input'
import useAuth from '../hooks/auth.hook'
import usePartnerApi from '../API/partner.api'


function PartnerAuth() {
  const [twoFA, setTwoFA] = useState(false)

  const login = useInput() 
  const password = useInput() 
  const code = useInput()

  const Partner = usePartnerApi()

  const auth = useAuth()

  const twoFAHandler = async () => { setTwoFA(await Partner.twoFA(login.value, password.value)) }
  
  const loginHandler = async () => { 
    const data = await Partner.verify(login.value, password.value, code.value)
    if(!data) { 
      code.clear()
      return setTwoFA(false) 
    }

    const {token, partnerId} = data
    auth.login(token, partnerId, true, 'PARTNER')
  }

  useEffect(() => {
    // if(twoFA) { code.focus() }
    // else { login.focus() }
  }, [twoFA])

  return (
    <>
      {twoFA? 
        <div className='card'>
          <div className={styles.main}>
            <h2 className={styles.title}>2FA</h2>
  
            <Input input={code} placeholder='Code' onComplite={loginHandler} />
            <button className='button' onClick={loginHandler}>Login</button> 
          </div>
        </div>
      : 
        <div className='card'>
          <div className={styles.main}>
            <h2 className={styles.title}>Merchant</h2>

            <Input input={login} placeholder='Login' onComplite={password.focus} />
            <Input input={password} type='password' placeholder='password' onComplite={twoFAHandler} />

            <button className='button' onClick={() => twoFAHandler()}>Login</button>
          </div>
        </div>
      }
    </>    
  )
}


export default PartnerAuth